import styled, { css } from "styled-components";

const invertPointMixin = css`
  border-radius: 100px 100px 100px 0;
`;

export const StyledButton = styled.button`
  user-select: none;
  cursor: pointer;
  font-size: 1.125rem;
  background: ${({ color }) => color};
  color: white;
  border: none;
  padding: 1.3em;
  border-radius: 100px;
  line-height: 0;
  @media (min-width: 600px) {
    padding: 2em;
    border-radius: 0 100px 100px;
    ${(props) =>
      props.size === "small"
        ? `
     padding: .8em;
    `
        : ""}
    ${(props) => (props.buttonStyle === "invert-point" ? invertPointMixin : "")}
  }
  ${(props) =>
    props.size === "small"
      ? `
     padding: .8em;
    `
      : ""}
  font-family: "Larsseit", "Roboto", sans-serif;
  outline: none;
  transition: all 0.2s;
  ${(props) => (props.buttonStyle === "invert-point" ? invertPointMixin : "")}

  &:hover,
  &:focus {
    box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.2),
      inset 0 5px 0 0 rgba(255, 255, 255, 0.2);
    text-shadow: 0 1px rgba(0, 0, 0, 0.2);
  }

  &:active {
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2), inset 0 5px 0 0 rgba(0, 0, 0, 0.1);
    text-shadow: -1px -1px rgba(0, 0, 0, 0.2);
  }
`;
